((blog, $) => {
  "use strict";
  const $dom = {};
  const cacheDom = () => {
    $dom.btnShare = $('[js-article="share"]');
    $dom.shareList = $('[js-article="share-list"]');
    $dom.imageCarousel = $('.image-slider');
    $dom.adInjectionPointWing = $(`[data-article-wing]`);
    $dom.adInjectionPoint = $(`.article-content__body > p`);
  }

  const bindUIActions = () => {
    $dom.btnShare.on('click', event => {
      event.preventDefault();
      event.stopPropagation();
      $dom.shareList.toggleClass('is-active');
    });

    $(document.body).on('click', event => {
      if($dom.shareList.hasClass('is-active')) {
        event.preventDefault();
        event.stopPropagation();
        $dom.shareList.removeClass('is-active');
      }
    });
  }

  const initImageCarousel = () => {
    $dom.imageCarousel.slick({
      autoplay: false,
      arrows: true,
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ]
    })
  }

  const buildArticleAd = (ad, extraClass = ``) => {
    return `
      <div class="article-ad ${ extraClass }">
        <a href="${ ad.url }"><img srcset="${ ad.image }, ${ ad.imageRetina } 2x" alt="${ ad.imageAlt }" /></a>
      </div>`
    ;
  }

  const initArticleAds = () => {
    if (!window.bvaccel || !window.bvaccel.articleAds) return;

    window.bvaccel.articleAds.wings.forEach((ad, index) => {
      const $wing = $dom.adInjectionPointWing.eq(index);
      if ($wing.length <= 0) return;

      const $ad = $(buildArticleAd(ad));
      $wing.append($ad);
    });
    const $injectionPoint = $dom.adInjectionPoint.length > 1 ? $dom.adInjectionPoint.eq(1) : $(`.article-content`);
    window.bvaccel.articleAds.desktop.forEach((ad) => {
      $injectionPoint.after(buildArticleAd(ad));
    });
    window.bvaccel.articleAds.mobile.forEach((ad) => {
      $injectionPoint.after(buildArticleAd(ad, `article-ad--mobile`));
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
    initImageCarousel();
    initArticleAds();
  };

  blog.init = init
})((window.blog = window.blog || {}), jQuery);